import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import noAllocationsImg from 'src/img/no-allocations.svg';
import useStyles from './styles';
export default function NoAllocations(_ref) {
  let name = _ref.name;
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    className: classes.wrapper
  }, /*#__PURE__*/React.createElement("img", {
    alt: "no allocations image",
    src: noAllocationsImg,
    height: "160",
    width: "160"
  }), /*#__PURE__*/React.createElement(Typography, {
    color: "light",
    variant: "h6"
  }, t('allocations.no_allocations_found'), name ? " before ".concat(name) : '.'));
}